import http from '@/api/base'

// 网关支付列表
const payOrderList = (params = {}) => {
  // params.mockApi = trues
  return http.post('/portal/order/list', params)
}
// 手续费打开的网关支付列表
const enterpriseOrderTotal = (params = {}) => {
  return http.post('/portal/fee/count/enterpriseOrderTotal ', params)
}

// 订单详情
const orderDetail = (params = {}) => {
  return http.post('/portal/order/detail', params)
}
// 账单查询导出账单
const exportOrderList = (params) => {
  return http.post('/portal/pay/exportOrderList', params, { responseType: 'blob' })
}

// 商户订单详情导出
const StoreDrawbackExport = (params) => {
  return http.get('/portal/merchants/withdraw/detail/export', params, { responseType: 'blob' })
}

// 充值订单中心列表查询
const rechargeOrderList = (params = {}) => {
  return http.post('/portal/ewallet/recharge-order/list', params)
}
// 退款订单列表查询
const refundOrderList = (params = {}) => {
  return http.post('/portal/refund/refundOrderList', params)
}
// 企业订单列表查询
const companyListQuery = (params = {}) => {
  return http.post('/portal/enterprise/pay/enterpriseWithdrawQuery', params)
}
// 商户订单列表查询
const storeListQuery = (params = {}) => {
  return http.post('/portal/merchants/withdraw/list-total', params)
}
// 商户订单列表查询 详情
const withdrawDetail = (params = {}) => {
  return http.get('/portal/merchants/withdraw/detail', {params})
}
// 充值订单中心列表查询
const withdrawList = (params = {}) => {
  return http.post('/portal/ewallet/withdraw/list', params)
}
// 财务管理 手续费管理
const countGetFeeCount = (params = {}) => {
  return http.post('/portal/fee/count/getFeeCount', params)
}
// .提现手续费 查询明细
const withdrawAmountTotal = (params = {}) => {
  return http.post('/portal/fee/count/withdrawAmountTotal', params)
}
// .提现手续费 营业抽成
const withdrawDetailList = (params = {}) => {
  return http.post('/portal/merchants/withdraw/withdrawDetailList', params)
}
// 财务管理 手续费管理 导出
const exportWithdrawAmountTotal = (params) => {
  return http.post('/portal/fee/count/exportWithdrawAmountTotal', params, { responseType: 'blob' })
}
// 财务管理 营业抽成 导出
const withdrawDetailListExport = (params) => {
  return http.post('/portal/merchants/withdraw/withdrawDetailList/export', params, { responseType: 'blob' })
}
// 提现 导出
const withdrawExport = (params) => {
  return http.post('/portal/ewallet/withdraw/exportCompanyInfo', params, { responseType: 'blob' })
}
// 充值 导出
const rechargeExport = (params) => {
  return http.post('/portal/ewallet/recharge-order/exportCompanyInfo', params, { responseType: 'blob' })
}
// 消费 导出
const orderExport = (params) => {
  return http.post('/portal/order/exportCompanyInfo', params, { responseType: 'blob' })
}
// 退款 导出
const refundOrderListExport = (params) => {
  return http.post('/portal/refund/exportCompanyInfo', params, { responseType: 'blob' })
}
// 企业提现 导出
const companyExport = (params) => {
  return http.post('/portal/enterprise/pay/exportEnterpriseWithdraw', params, { responseType: 'blob' })
}
// 充值管理 导出
const subsidyOrderExport = (params) => {
  return http.post('/portal/subsidy/order/export', params, { responseType: 'blob' })
}
// 商户提现 导出
const storeExport = (params) => {
  return http.post('/portal/merchants/withdraw/export', params, { responseType: 'blob' })
}

// 申请开票详情信息查询
const getApplyApplyInfo = (params) => {
  return http.post('/portal/invoice/getApplyApplyInfo', params)
}
// 获取停车场列表
const getParkingLotList = (params) => {
  return http.post('/ipark-admin/parkingLot/getParkingLotList', params)
}

export default {
  payOrderList,
  refundOrderList,
  orderDetail,
  exportOrderList,
  withdrawList,
  rechargeOrderList,
  withdrawExport,
  rechargeExport,
  orderExport,
  refundOrderListExport,
  storeExport,
  storeListQuery,
  companyListQuery,
  companyExport,
  withdrawDetail,
  subsidyOrderExport,
  StoreDrawbackExport,
  countGetFeeCount,
  exportWithdrawAmountTotal,
  withdrawAmountTotal,
  withdrawDetailList,
  withdrawDetailListExport,
  enterpriseOrderTotal,
  getApplyApplyInfo,
  getParkingLotList
}



// WEBPACK FOOTER //
// ./src/area-apartment/api/payService.js